module.exports = "/img/_/_/_/assets/images/icon//experience.png?2225f12db362fb06cbfebb46b95b858b";